import MayoLogo from "../common/MayoLogo";
import MayoVideoHeader from "../common/MayoVideoHeader";

import videoThumbnail from "../../../../assets/Mayo/thumbnail4.jpg";
import styled from "styled-components";
import MayoCareItem from "../common/MayoCareItem";
import MedInstruction from "../common/MedInstruction";
import ListBox from "../common/ListBox";
import Animation from "../common/Animation";
import HealthWarning from "../common/HealthWarning";
import redFlagAnimation from "../../../../assets/Mayo/Red_Flag_In_Circle.json";
import MayoFooter from "../common/MayoFooter";
import MayoContactSection from "../common/ContactSection";
import MayoRecommendation from "../common/MayoRecommendation";

import sportImg from "../../../../assets/Mayo/sport.png"
import bagImg from "../../../../assets/Mayo/bag.png"
import medsImg from "../../../../assets/Mayo/meds.png"
import scaleImg from "../../../../assets/Mayo/scale.png"
import redArrow from "../../../../assets/Mayo/red_arrow.svg"
import bgImg from "../../../../assets/Mayo/bg_1_for_videe_pages.svg"

const POST_PROCEDURE_WARNING_SIGNS = [
  {margin: "0", icon: redArrow, iconStyle: {height: 14, width: 6, marginRight: 18, marginTop: 5}, text: "New or expanding swelling."},
  {margin: "0", icon: redArrow, iconStyle: {height: 14, width: 6, marginRight: 18, marginTop: 5}, text: "Pain or discomfort at the puncture site."},
  {margin: "0", icon: redArrow, iconStyle: {height: 14, width: 6, marginRight: 18, marginTop: 5}, text: "Signs of infection (redness, drainage, fever)."},
  {margin: "0", icon: redArrow, iconStyle: {height: 14, width: 6, marginRight: 18, marginTop: 5}, text: "Change in color, temperature or sensation in the arm or leg that is the site of the puncture."},
  {margin: "0", icon: redArrow, iconStyle: {height: 14, width: 6, marginRight: 18, marginTop: 5}, text: "Unusual feeling of weakness or faintness."},
]

export default function MayoVideoPage3() {
  return (
    <Container>
      <MayoLogo />
      <MayoVideoHeader 
        postAnalyticType={"watchedVideoAngiogram"}
        title="Your recovery journey starts here!"
        videoThumbnail={videoThumbnail}
        disableVideo={true}
      />

      <HL style={{marginTop: 5, marginBottom: 30}}/>

      <Title>
        Caring for yourself after TAVR
      </Title>

      <MayoCareItem 
        image={sportImg}
        imageSize={{width: 130, height: 90}}
        title={"Activities"}
        items={[
          "You may return to your normal activities four weeks after surgery.",
          [ "No lifting more than 10 lbs. for one week.", 
            "No lifting more than 50 lbs. for two weeks.", 
            "No driving for 3 days minimum (2 weeks if going home with a heart monitor)."],
          "Ask your health care provider when you can exercise."
        ]}
      />

      <HL style={{marginTop: 30, marginBottom: 30}}/>

      <MayoCareItem 
        image={bagImg}
        imageSize={{width: 108, height: 96}}
        title={"Incision Care"}
        items={["Leave the incision site open to air. Do not put cream or lotion on the area. Cover the site with gauze only if there is drainage from it.",
          "For the next 7 days - do not take baths or soak in a tub and avoid scrubbing the area where the catheter was inserted. Pat the incisions dry.",
          "Check the insertion site every day for redness, warmth, new tenderness or drainage. If you have any of these, tell your health care provider within 24 hours.",
          "If you have SteriStrips™️, which are small strips of tape over your incisions, let them fall off on their own, which usually happens in one to two weeks." 
        ]}
      />

      <HL style={{marginBlock: 30}}/>

      <MayoCareItem
        image={scaleImg}
        imageSize={{width: 90, height: 89}}
        title={"Monitoring your weight"}
        items={[
          "Weigh yourself every day until your first follow-up appointment with your primary health care provider. If your weight increases by 2 pounds for 2 days in a row, call your primary health care provider."
        ]}
      />

      <HL style={{marginBlock: 30}}/>

      <MayoCareItem 
        image={medsImg}
        imageSize={{width: 112, height: 100}}
        title={"Medications"}
        items={[
          "Your prescribed medications will wait for you at the nearest pharmacy to your home."
        ]}
      />

      <HL style={{marginBlock: 30}}/>

      <Animation 
        animationSrc={redFlagAnimation}
        style={{
          width: 64,
          height: 64,
          marginLeft: 26,
          marginBlock: 24
        }}
      />

      <ListBox
        noBorder={true}
        style={{marginBottom: 21, marginLeft: 26, marginRight: 25}}
        headerMargin={"0 0 18px 0"}
        title={"Post-procedure warning signs! call your personal physician if any of the following appears:"}
        list={POST_PROCEDURE_WARNING_SIGNS}
        Component={MedInstruction}
      />

      <HealthWarning />
      
      <ListBox 
        style={{padding: 0, paddingInline: 17, paddingTop: 14, marginTop: 40, marginBottom: 50}}
        list={[0]}
        Component={MayoRecommendation}
      />

      <MayoContactSection />
      <HL style={{marginTop: 32}}/>
      <MayoFooter />
    </Container>
  );
}

const Container = styled.div`
  font-family: Abraham;
  color: #1A1A1A;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const HL = styled.div`
  min-height: 1px;
  background-color: #7A9DFD;
  opacity: 40%;
  margin-inline: 26px;
`

const Title = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 24px;
  color: #1A1A1A;
  margin-inline: 26px;
  margin-bottom: 30px;
`
